// Which session objectives each part of a task document teaches.
//
// The objectives box at the top of the doc says what the task practises; this carries
// the same numbers down into the document itself, so a reader can see WHERE each one is
// covered rather than only that it is. Numbers are the ones from objectivesScreen.js
// (continuous 1..6 across both groups), so "objective 3" means the same thing on the
// objectives screen, in the box, and here.
//
// Matching is on the raw markdown line — headings and bold leads only — because the
// canonical task docs are generated and must not be edited to carry markup of their own.
// A section with no entry simply gets no badge; partial coverage is expected and fine.
const RULES = {
  a1: [
    [/^### Introduction to Trio/, [1, 2, 3]],
    [/^#### Trio's `sleep` Function/, [4]],
    [/^### Task 1: Beginner Async Functions/, [1, 2, 4]],
    [/^\*\*Expected Output\*\*/, [4]]
  ],
  b1: [
    [/^## Task 2: Error Handling in Async Code/, [5, 6]],
    [/^\*\*Expected Output\*\*/, [6]]
  ],
  a2: [
    [/^# Task: System Startup Sequence/, [1, 2, 3]],
    [/^\*\*Expected Output\*\*/, [4]]
  ],
  b2: [
    [/^# Task: Resilient Record Retrieval/, [5, 6]],
    [/^\*\*Expected Output\*\*/, [6]]
  ]
}

export function objectivesForLine (taskId, line) {
  const rules = RULES[taskId]
  if (!rules) return null                       // warm-up teaches no session objective
  for (const [re, ns] of rules) if (re.test(line)) return ns
  return null
}
